export const BUTTON_TYPES = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  LINK: 'link',
}

export const BUTTON_STYLES = {
  THIN: 'thinButton',
  PRIMARY: 'primaryButton',
  SECONDARY: 'secondaryButton',
};

export const BUTTON_BEHAVIORS = {
  REDIRECT: 'redirect',
  ALERT: 'alert',
}
